<script setup>
import VehicleCell from "../simulation/VehicleCell.vue";
defineProps({
  vehicles: {
    type: Array,
    default: void 0
  },
  hasIncompatibility: {
    type: Boolean,
    default: false
  }
});
defineEmits(["selectVehicle", "deleteVehicle", "modifyVehicle", "setVehicleAsDefault", "addVehicle"]);
</script>

<template>
    <div class="w-full flex flex-col items-center gap-6">
        <div class="w-full flex flex-col items-center gap-2">
            <IconCar class="size-12 md:size-16 text-icon-secondary-branding" />
            <span
                class="text-[17px] md:text-[22px] text-header-dark font-bold leading-5 md:leading-[25px]"
            >
                {{ $t("user_vehicles.titles.overview") }}
            </span>
        </div>
        <div class="w-full flex flex-col items-center gap-6">
            <div class="w-full flex flex-col items-center gap-2">
                <VehicleCell
                    v-for="vehicle in vehicles"
                    :key="vehicle.versionId"
                    :vehicle
                    is-standalone
                    is-selector
                    :is-selected="vehicle.isSelected"
                    :is-checked="vehicle.isDefault"
                    :is-disabled="vehicle.isIncompatible"
                    @selectVehicle="$emit('selectVehicle', $event)"
                    @modifyVehicle="$emit('modifyVehicle', $event)"
                    @deleteVehicle="$emit('deleteVehicle', $event)"
                    @setVehicleAsDefault="$emit('setVehicleAsDefault', $event)"
                />
            </div>

            <div
                v-if="hasIncompatibility"
                class="w-full flex items-start p-1 gap-1"
            >
                <IconInfoCircle
                    isSolid
                    class="size-4 text-icon-secondary-neutral"
                />
                <span
                    class="text-[11px] md:text-[13px] text-gray-l-500 font-normal leading-4"
                >
                    {{ $t("user_vehicles.overview.incompatibility") }}
                </span>
            </div>

            <ChargemapB2CButton
                type="secondary"
                size="large"
                @click="$emit('addVehicle')"
            >
                {{ $t("user_vehicles.overview.add") }}
                <IconPlus class="w-7 text-button-tertiary-neutral" />
            </ChargemapB2CButton>
        </div>
    </div>
</template>
